import { useEventBus } from '@vueuse/core';

export default useEventBus<CommonObject>('fetchResponse');
